import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addTransaction: 'Add another transaction',
    confirm: 'Confirm my dispute',
    error:
      'An error occurred, please try again later. Contact support if the problem persists.',
    important: 'Important',
    legalMention:
      'By proceeding, you confirm that your dispute is legitimate and that the listed transactions are fraudulent. Any false statement may result in legal action (art. 1240 of the Civil Code).',
    send: 'Send my dispute',
    title: 'Dispute transactions',
    transactionCount: '{count} transaction to dispute',
    transactionsCount: '{count} transactions to dispute',
    warning:
      'Warning, some of the selected transactions have been validated with strong authentication and may not be eligible for reimbursement.',
  },
  fr: {
    addTransaction: 'Ajouter une autre transaction',
    confirm: 'Confirmer ma contestation',
    error:
      'Une erreur est survenue, veuillez réessayer ultérieurement. Contactez le support si le problème persiste.',
    important: 'Important',
    legalMention:
      'En poursuivant, vous confirmez que votre contestation est légitime et que les opérations listées sont frauduleuses. Toute déclaration mensongère pourra donner lieu à des poursuites (art. 1240 du Code civil).',
    send: 'Envoyer ma contestation',
    title: 'Contester des opérations',
    transactionCount: '{count} opération à contester',
    transactionsCount: '{count} opérations à contester',
    warning:
      'Attention, certaines des opérations sélectionnées ont été validées avec une authentification forte et ne seront peut-être pas éligibles au remboursement.',
  },
} as const);

export default locales;
